export default {"src":"https://images-cdn.curipod.com/d-bdb94e66/_next/static/media/friday.eeee48f3.svg","height":157,"width":344};